import request from '../request.js'

/**
 * 查询轮询失败日志列表
 */
export function getFailureLogList(params) {
  return request({
    url: '/polling/failureLog/list.do?',
    method: 'get',
    params
  })
}

/**
 * 获取统计信息
 */
export function getFailureStats(params) {
  return request({
    url: '/polling/failureLog/stats.do?',
    method: 'get',
    params
  })
}

/**
 * 手动同步Redis数据到数据库
 */
export function manualSync(date) {
  return request({
    url: '/polling/failureLog/manualSync.do?',
    method: 'post',
    params: { date }
  })
}

/**
 * 查询指定卡号的失败历史
 */
export function queryByIccid(iccidMark) {
  return request({
    url: '/polling/failureLog/queryByIccid.do?',
    method: 'get',
    params: { iccidMark }
  })
}

/**
 * 导出Excel（返回文件流）
 */
export function exportFailureLog(params) {
  return request({
    url: '/polling/failureLog/export.do?',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

